import { useContext } from 'react';
import Link from 'components/gruenland/atoms/link';
import Typography from 'components/gruenland/atoms/typography';
import { AccountContext } from 'context/account';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_PRIVATE_AREA_TITLE } from 'lib/typography';
import { AccountTab } from '../..';
import DashboardCard from './DashboardCard';

type Props = {
  tabs: AccountTab[];
};

const DashboardSection: React.FC<Props> = ({ tabs }) => {
  const { account, accountLoading } = useContext(AccountContext);
  const { formatMessage } = useFormat({ name: 'gruenland' });
  return (
    !accountLoading && (
      <>
        <Typography as="h2" className={TYPOGRAPHY_PRIVATE_AREA_TITLE}>
          {formatMessage({
            id: 'privatearea.hello',
            defaultMessage: 'Ciao {firstname}',
            values: { firstname: account?.firstName || '' },
          })}
        </Typography>

        {/* TODO: Refactor side menu, add links here */}
        <div className="mt-5 grid gap-5 md:grid-cols-2">
          {tabs.map((tab) => (
            <Link link={tab.href} key={tab.name}>
              <DashboardCard>{tab.name}</DashboardCard>
            </Link>
          ))}
        </div>
      </>
    )
  );
};

export default DashboardSection;
